"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidBookingInput = exports.bookingInputKeys = exports.isBunkerDeliveryNote = exports.isPeriodicalStatement = exports.isIntensities = exports.isForecast = exports.isValidTransactionInput = exports.transactionInputKeys = exports.fleetInputKeys = exports.isValidPortInputEdit = exports.isValidPortInput = exports.portInputKeys = exports.poolInputKeys = exports.isValidFleetInput = exports.isValidUserInput = exports.isValidBalancePlanInput = exports.isValidShipInput = exports.shipInputKeys = exports.forecastSourceOptions = exports.isValidIMO = exports.isShipEngineType = exports.isValidCompanyYearlyDataInput = void 0;
const lodash_1 = require("lodash");
const isNullish_1 = require("../../util/isNullish");
const isValidCompanyYearlyDataInput = (data) => {
    return ((0, lodash_1.isNumber)(data.year) &&
        (0, lodash_1.isNumber)(data.company_id) &&
        (0, lodash_1.isNumber)(data.compliance_selling_price) &&
        (0, lodash_1.isNumber)(data.compliance_buying_price) &&
        !(0, isNullish_1.isNullish)(data.currency) &&
        data.currency !== "");
};
exports.isValidCompanyYearlyDataInput = isValidCompanyYearlyDataInput;
const isShipEngineType = (obj) => {
    return (typeof obj === "object" &&
        obj !== null &&
        (typeof obj.id === "number" || obj.id === undefined) &&
        typeof obj.type === "number" &&
        typeof obj.ship_engine_type === "number");
};
exports.isShipEngineType = isShipEngineType;
const imoRegex = /^\d{7}$/;
const isValidIMO = (imoString) => {
    return imoRegex.test(imoString);
};
exports.isValidIMO = isValidIMO;
exports.forecastSourceOptions = [
    { label: "Automatic", value: 1 },
    { label: "Balance plan", value: 2 },
    { label: "Voyage forecast", value: 3 },
];
exports.shipInputKeys = [
    "id",
    "name",
    "imo",
    "fleet_id",
    "pool",
    "ice_class",
    "company_id",
    "engines",
    "wind_propulsion",
    "doc_holder_id",
    "verifier",
];
const isValidShipInput = (ship) => {
    return (!(0, isNullish_1.isNullish)(ship.name) &&
        ship.name !== "" &&
        !(0, isNullish_1.isNullish)(ship.imo) &&
        (0, exports.isValidIMO)(ship.imo) &&
        !(0, isNullish_1.isNullish)(ship.fleet_id) &&
        !(0, isNullish_1.isNullish)(ship.engines) &&
        ship.engines.length > 0 &&
        (0, lodash_1.every)(ship.engines, (engine) => (0, exports.isShipEngineType)(engine)));
};
exports.isValidShipInput = isValidShipInput;
const isValidBalancePlanInput = (plan) => {
    return ((0, lodash_1.isNumber)(plan.ship_id) && (0, lodash_1.isNumber)(plan.balance) && (0, lodash_1.isNumber)(plan.year));
};
exports.isValidBalancePlanInput = isValidBalancePlanInput;
const isValidUserInput = (user) => {
    return (!(0, isNullish_1.isNullish)(user.username) &&
        user.username !== "" &&
        !(0, isNullish_1.isNullish)(user.company_id));
};
exports.isValidUserInput = isValidUserInput;
const isValidFleetInput = (fleet) => {
    return (!(0, isNullish_1.isNullish)(fleet.name) && fleet.name !== "" && !(0, isNullish_1.isNullish)(fleet.company_id));
};
exports.isValidFleetInput = isValidFleetInput;
exports.poolInputKeys = ["id", "name", "year"];
exports.portInputKeys = [
    "id",
    "name",
    "un_code",
    "country",
    "latitude",
    "longitude",
    "port_region",
    "region_code",
];
const hasAll = (obj, keys) => keys.every((k) => !(0, isNullish_1.isNullish)(obj[k]));
const portRequiredKeysWithoutId = [
    "name",
    "un_code",
    "country",
    "latitude",
    "longitude",
    "port_region",
    "region_code",
];
const isValidPortInput = (port) => hasAll(port, portRequiredKeysWithoutId);
exports.isValidPortInput = isValidPortInput;
const isValidPortInputEdit = (port) => hasAll(port, ["id", ...portRequiredKeysWithoutId]);
exports.isValidPortInputEdit = isValidPortInputEdit;
exports.fleetInputKeys = ["id", "name", "company_id"];
exports.transactionInputKeys = [
    "id",
    "to",
    "from",
    "pool_id",
    "quantity",
    "production_cost",
    "alternative_cost",
    "transaction_cost",
    "eu_ets_benefit",
    "transaction_date",
    "year",
    "periodical_statement_id",
];
const isValidTransactionInput = (transaction) => {
    return ((0, lodash_1.isNumber)(transaction.from) &&
        (0, lodash_1.isNumber)(transaction.to) &&
        (0, lodash_1.isNumber)(transaction.alternative_cost) &&
        (0, lodash_1.isNumber)(transaction.eu_ets_benefit) &&
        (0, lodash_1.isNumber)(transaction.pool_id) &&
        (0, lodash_1.isNumber)(transaction.year) &&
        (0, lodash_1.isString)(transaction.transaction_date) &&
        (0, lodash_1.isNumber)(transaction.quantity) &&
        (0, lodash_1.isNumber)(transaction.production_cost) &&
        (0, lodash_1.isNumber)(transaction.transaction_cost));
};
exports.isValidTransactionInput = isValidTransactionInput;
const isForecast = (value) => {
    return !(0, isNullish_1.isNullish)(value) && !(0, lodash_1.isArray)(value);
};
exports.isForecast = isForecast;
const isIntensities = (value) => {
    return !(0, isNullish_1.isNullish)(value) && !(0, lodash_1.isArray)(value);
};
exports.isIntensities = isIntensities;
const isPeriodicalStatement = (attachment) => {
    return attachment.type === 1;
};
exports.isPeriodicalStatement = isPeriodicalStatement;
const isBunkerDeliveryNote = (attachment) => {
    return attachment.type === 2;
};
exports.isBunkerDeliveryNote = isBunkerDeliveryNote;
exports.bookingInputKeys = [
    "id",
    "pool_id",
    "company_id",
    "year",
    "quantity_tco2e",
];
const isValidBookingInput = (booking) => {
    return ((0, lodash_1.isNumber)(booking.pool_id) &&
        (0, lodash_1.isNumber)(booking.company_id) &&
        (0, lodash_1.isNumber)(booking.year) &&
        (0, lodash_1.isNumber)(booking.quantity_tco2e));
};
exports.isValidBookingInput = isValidBookingInput;
